import React from 'react';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { LightSwitch } from '@ff-os/shared-react/components/light-switch/LightSwitch';
import { PreviewUiElement } from '@ff-os/shared-react/components/preview-ui-element/PreviewUiElement';
import { ArPreviewStatus } from '@ff-scene-plugins/gift-redux/slices/uiSlice';
import { ArPreviewButton } from '../preview/ArPreviewButton';
import { Controls3dTooltip } from './Controls3dTooltip';
import styles from '../GiftPreviewUi.module.scss';

export const Controls3d = ({ set3d, show3d, showArStatus }: Props) => (
    <Grid className={styles.controls3d} direction='column' justify='start' align='start' gap='xs'>
        <Cell fit>
            <PreviewUiElement className={styles.toggle}>
                <LightSwitch checked={show3d} onChange={set3d}>
                    <Icon size='small' type='three-dimensional' stroke='none' fill='currentColor' />
                </LightSwitch>
            </PreviewUiElement>
        </Cell>

        {show3d && showArStatus !== 'disabled' && (
            <Cell>
                <ArPreviewButton />
            </Cell>
        )}

        {show3d && (
            <Cell>
                <Controls3dTooltip />
            </Cell>
        )}
    </Grid>
);

type Props = {
    show3d: boolean;
    showArStatus: ArPreviewStatus;
    set3d: (show3d: boolean) => void;
};